import React, { useState } from "react";
import { Button, Flex, List, Typography, Spin, Rate, Input } from "antd";

type Props = {
  user?: string;
};

const { Text } = Typography;

const { TextArea } = Input;

export const OrderRating = ({ user = "asd" }: Props) => {
  const [rateValue, setRateValue] = useState(4);

  return (
    <Spin spinning={false} tip="Generating invoice">
      <List className="summary-list" itemLayout="vertical" size="large">
        <List.Item>
          {/* <Flex vertical gap={24}>
            <Flex>
              <Text>The experience you provide to your clients</Text>
            </Flex>
            <Flex vertical gap={8}>
              <Text strong type="secondary">
                Rating
              </Text>
              <Rate onChange={setRateValue} value={rateValue} />
            </Flex>

            <Flex vertical gap={8}>
              <Text strong type="secondary">
                Coment
              </Text>
              <TextArea
                defaultValue={
                  "Excelente!!!!. Además del muy buen precio, me lo trajeron a casa al día siguiente!!!!. Todo perfecto "
                }
                rows={4}
              />
              <Text style={{ fontSize: 12, marginTop: 12 }}>
                If you believe the rating was unfair, contact the customer to
                find out what happened.
              </Text>
            </Flex>

            <Flex justify="end" style={{ marginTop: 24 }}>
              <Button>Report rating</Button>
            </Flex>
          </Flex> */}
          <Text type="secondary" italic>
            {" "}
            Estamos trabajando en esta sección, próximamente podrás ver la
            valoración de los pedidos.
          </Text>
        </List.Item>
      </List>
    </Spin>
  );
};
